import { useState, type FormEvent } from 'react';
import { changePassword } from './password-change-api';
import '../styles/modules-my-account-password-change.css';

export function PasswordChangePanel(): React.JSX.Element {
  const [currentPassword, setCurrentPassword] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    if (pending) return;

    if (newPassword !== newPasswordConfirmation) {
      setError('Les deux saisies du nouveau mot de passe ne correspondent pas.');
      return;
    }

    setPending(true);
    setError(null);
    try {
      await changePassword({ currentPassword, totpCode, newPassword });
      window.location.replace('/');
    } catch {
      setError('Le mot de passe ne peut pas être modifié. Vérifiez les informations saisies.');
      setPending(false);
    }
  }

  return (
    <form className="my-account-password-form" onSubmit={(event) => void submit(event)}>
      <p className="my-account-password-help">
        Votre nouveau mot de passe doit contenir entre 15 et 128 caractères. Après modification,
        toutes vos sessions seront déconnectées et vous devrez vous reconnecter.
      </p>
      <label>
        <span>Mot de passe actuel</span>
        <input
          type="password"
          autoComplete="current-password"
          value={currentPassword}
          onChange={(event) => setCurrentPassword(event.target.value)}
          required
        />
      </label>
      <label>
        <span>Code d’authentification</span>
        <input
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          value={totpCode}
          onChange={(event) => setTotpCode(event.target.value)}
          required
        />
      </label>
      <label>
        <span>Nouveau mot de passe</span>
        <input
          type="password"
          autoComplete="new-password"
          minLength={15}
          maxLength={128}
          value={newPassword}
          onChange={(event) => setNewPassword(event.target.value)}
          required
        />
      </label>
      <label>
        <span>Confirmer le nouveau mot de passe</span>
        <input
          type="password"
          autoComplete="new-password"
          minLength={15}
          maxLength={128}
          value={newPasswordConfirmation}
          onChange={(event) => setNewPasswordConfirmation(event.target.value)}
          required
        />
      </label>
      {error ? (
        <p className="my-account-password-error tosho-feedback is-error" role="alert">
          {error}
        </p>
      ) : null}
      <div className="my-account-password-actions">
        <button type="submit" className="my-account-password-primary" disabled={pending}>
          {pending ? 'Modification…' : 'Modifier le mot de passe'}
        </button>
      </div>
    </form>
  );
}
